module.exports = __webpack_public_path__ + "img/button _QR_pink.d00d283c.png";